<template>
  <RoutinesForm
    :routines-prop="routines"
    :subject-permission="subjectPermission"
    @save-routine="saveConfig"
  />
</template>

<script>
import routineApiService from '../../../../services/routine.api';
import { AUTO } from '../../../../constants/tipo.apolice';
import notify from '../../../../utils/notify';
import RoutinesForm from '../../../forms/RoutinesForm.vue';

export default {
  name: 'RoutinesAuto',
  props: {
    subjectPermission: {
      type: String,
      default: '',
    },
  },
  components: {
    RoutinesForm,
  },
  data() {
    return {
      routines: [],
    };
  },
  async mounted() {
    this.getRoutineConfigs();
  },
  methods: {
    getRoutineConfigs() {
      this.$vs.loading();
      routineApiService
        .getRoutinesByProduct(AUTO)
        .then((response) => {
          this.$vs.loading.close();
          this.routines = response;
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-right',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        });
    },
    saveConfig(payload) {
      this.$vs.loading();
      routineApiService
        .save(payload)
        .then(() => {
          this.$vs.loading.close();
          notify.notifySuccess(this.$vs, 'Rotina salva com sucesso');
          this.getRoutineConfigs();
        })
        .catch((error) => {
          this.$vs.loading.close();
          notify.notifyError(this.$vs, error);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
